import React from "react";

interface StepItemProps {
  number: number;
  title: string;
  description: string;
  theme?: "light" | "dark";
}

function StepItem({
  number,
  title,
  description,
  theme = "light",
}: StepItemProps) {
  const circleBg =
    theme === "dark" ? "bg-[#073133] text-white" : "bg-[#073133] text-white";
  return (
    <div className="flex flex-col items-start w-full mb-4 md:mb-0">
      <div className="flex items-center mb-1 md:mb-2">
        <span
          className={`flex items-center justify-center w-8 h-8 rounded-full font-bold text-base md:text-lg mr-3 ${circleBg}`}
        >
          {number}
        </span>
        <span className="font-bold text-base md:text-lg leading-tight">
          {title}
        </span>
      </div>
      <span className="text-base md:text-lg text-gray-700 dark:text-gray-200 leading-snug ml-11">
        {description}
      </span>
    </div>
  );
}

export default StepItem;
